import { useState } from "react";
import { mockAdminUsers } from "@/mocks/dealerData";

export default function AdminUsersPage() {
  const [users, setUsers] = useState(mockAdminUsers);
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState({ username: "", password: "", role: "admin" });

  const addUser = () => {
    if (!form.username.trim() || !form.password.trim()) return;
    const newUser = {
      id: "au" + Date.now(),
      username: form.username,
      password: form.password,
      role: form.role,
      createdAt: new Date().toISOString(),
    };
    setUsers((prev) => [...prev, newUser]);
    setForm({ username: "", password: "", role: "admin" });
    setShowModal(false);
  };

  const deleteUser = (id: string) => {
    setUsers((prev) => prev.filter((u) => u.id !== id));
  };

  return (
    <div className="max-w-5xl mx-auto">
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-6">
        <div>
          <h4 className="text-lg font-semibold text-foreground-950"><a id="admin-users">Kullanıcı Yönetimi</a></h4>
          <p className="text-sm text-foreground-500 mt-0.5">Admin paneli kullanıcılarını yönetin</p>
        </div>
        <button onClick={() => setShowModal(true)} className="flex items-center gap-2 px-4 py-2 bg-accent-500 hover:bg-accent-600 text-background-50 rounded-lg text-sm font-medium transition-colors cursor-pointer whitespace-nowrap">
          <i className="ri-add-line"></i> Kullanıcı Ekle
        </button>
      </div>

      <div className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden">
        {/* Desktop Table */}
        <div className="overflow-x-auto hidden md:block">
          <table className="w-full text-sm min-w-[500px]">
            <thead>
              <tr className="bg-background-100 text-left">
                <th className="px-4 py-3 text-xs font-medium text-foreground-500">Kullanıcı Adı</th>
                <th className="px-4 py-3 text-xs font-medium text-foreground-500">Rol</th>
                <th className="px-4 py-3 text-xs font-medium text-foreground-500">Eklenme Tarihi</th>
                <th className="px-4 py-3 text-xs font-medium text-foreground-500 text-center">İşlem</th>
              </tr>
            </thead>
            <tbody>
              {users.map((u) => (
                <tr key={u.id} className="border-t border-background-200/70 hover:bg-background-100/50 transition-colors">
                  <td className="px-4 py-3 font-medium text-foreground-900">{u.username}</td>
                  <td className="px-4 py-3">
                    <span className={`inline-flex px-2 py-0.5 rounded-full text-xs font-medium ${u.role === "super_admin" ? "bg-accent-100 text-accent-700" : "bg-primary-100 text-primary-700"}`}>
                      {u.role === "super_admin" ? "Süper Admin" : "Admin"}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-foreground-600 text-xs">{new Date(u.createdAt).toLocaleDateString("tr-TR")}</td>
                  <td className="px-4 py-3">
                    <div className="flex items-center justify-center gap-1">
                      <button onClick={() => deleteUser(u.id)} className="w-7 h-7 rounded-md flex items-center justify-center text-foreground-400 hover:text-accent-500 hover:bg-accent-100 cursor-pointer"><i className="ri-delete-bin-line text-sm"></i></button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Mobile Cards */}
        <div className="md:hidden divide-y divide-background-200/70">
          {users.map((u) => (
            <div key={u.id} className="p-4 flex items-center justify-between">
              <div>
                <p className="font-medium text-foreground-900 text-sm">{u.username}</p>
                <div className="flex items-center gap-2 mt-1">
                  <span className={`inline-flex px-2 py-0.5 rounded-full text-xs font-medium ${u.role === "super_admin" ? "bg-accent-100 text-accent-700" : "bg-primary-100 text-primary-700"}`}>
                    {u.role === "super_admin" ? "Süper Admin" : "Admin"}
                  </span>
                  <span className="text-xs text-foreground-400">{new Date(u.createdAt).toLocaleDateString("tr-TR")}</span>
                </div>
              </div>
              <button onClick={() => deleteUser(u.id)} className="w-8 h-8 rounded-md flex items-center justify-center text-foreground-400 hover:text-accent-500 hover:bg-accent-100 cursor-pointer active:scale-[0.98]"><i className="ri-delete-bin-line text-sm"></i></button>
            </div>
          ))}
        </div>
      </div>

      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30" onClick={() => setShowModal(false)}>
          <div className="bg-background-50 rounded-2xl p-6 w-full max-w-sm mx-4" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between mb-4">
              <h4 className="text-base font-semibold text-foreground-950"><a id="add-user">Yeni Admin Kullanıcısı</a></h4>
              <button onClick={() => setShowModal(false)} className="w-8 h-8 rounded-md flex items-center justify-center text-foreground-400 hover:bg-background-100 cursor-pointer"><i className="ri-close-line"></i></button>
            </div>
            <div className="space-y-3">
              <div><label className="block text-xs font-medium text-foreground-500 mb-1">Kullanıcı Adı *</label><input type="text" value={form.username} onChange={(e) => setForm({ ...form, username: e.target.value })} className="w-full px-3 py-2 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-accent-400" /></div>
              <div><label className="block text-xs font-medium text-foreground-500 mb-1">Şifre *</label><input type="text" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="w-full px-3 py-2 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-accent-400" /></div>
              <div><label className="block text-xs font-medium text-foreground-500 mb-1">Rol</label><select value={form.role} onChange={(e) => setForm({ ...form, role: e.target.value })} className="w-full px-3 py-2 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-accent-400"><option value="admin">Admin</option><option value="super_admin">Süper Admin</option></select></div>
            </div>
            <div className="flex gap-2 mt-4">
              <button onClick={() => setShowModal(false)} className="flex-1 py-2.5 bg-background-100 border border-background-200/70 text-foreground-600 rounded-lg text-sm font-medium hover:bg-background-200/70 transition-colors cursor-pointer whitespace-nowrap">İptal</button>
              <button onClick={addUser} className="flex-1 py-2.5 bg-accent-500 hover:bg-accent-600 text-background-50 rounded-lg text-sm font-medium transition-colors cursor-pointer whitespace-nowrap">Kaydet</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}